import React from "react";
import PasswordSet from "./PasswordSet";

const PasswordSetRoute = () => {
  return <PasswordSet />;
};

export default PasswordSetRoute;
